import './ReferralStatusUpdateDrawer.scss'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withRouter } from 'react-router'
import { BottomDrawer } from 'common/views/atoms/BottomDrawer/BottomDrawer'
import cx from 'classnames'
import {
  RM_AGENT_STATUS_BTN_LABEL,
  RM_AGENT_LEASE_STATUS_BTN_LABEL,
  AGENT_STATUS_SPOKE,
  AGENT_STATUS_MET,
  AGENT_STATUS_OFFER,
  AGENT_STATUS_CONTRACT,
  AGENT_STATUS_CLOSED,
} from 'common/constants'
import { StatusMetForm } from 'manager/views/components/ReferralStatus/StatusMetForm'
import { StatusSpokeForm } from 'manager/views/components/ReferralStatus/StatusSpokeForm'
import { StatusOfferForm } from 'manager/views/components/ReferralStatus/StatusOfferForm'
import { StatusContractForm } from 'manager/views/components/ReferralStatus/StatusContractForm'
import { StatusClosedForm } from 'manager/views/components/ReferralStatus/StatusClosedForm'
import { labelFor } from 'common/util/helper'
import { compareStatus } from 'manager/util/helper'
import { setSelectedStatus, closeStatusDrawer } from 'manager/redux/referral_status'
import { show as showModal } from 'redux-modal'
import { selectIsLease, selectAgentStatus } from 'manager/selectors/referral_selectors'


const STATUS_BUTTONS = [AGENT_STATUS_SPOKE, AGENT_STATUS_MET, AGENT_STATUS_OFFER, AGENT_STATUS_CONTRACT, AGENT_STATUS_CLOSED]

const StatusButton = ({ checked, previous, onClick, disabled, children }) => {
  const className = cx("StatusUpdateDrawer__status-button", {
    checked,
    previous: previous && !checked
  })

  return (
    <button className={className} onClick={!disabled && onClick}>
      {(checked || previous) && <i className="fa fa-check" />}
      {children}
    </button>
  )
}

class StatusUpdateDrawer extends Component {

  state = {
    isClean: true
  }

  render() {
    const { location, setSelectedStatus, closeStatusDrawer, currentStatus, is_lease, showModal } = this.props

    const selectedStatus = location.query.editstatus
    const statusLabels = is_lease ? RM_AGENT_LEASE_STATUS_BTN_LABEL : RM_AGENT_STATUS_BTN_LABEL

    const onStatusClick = status => {
      this.setState({ isClean: false }, () => {
        if (compareStatus(currentStatus, status) > 0) {
          showModal('BackwardStatusWarningModal', { onConfirm: () => setSelectedStatus(status) })
        } else {
          setSelectedStatus(status)
        }
      })
    }

    const onClose = evt => {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage('status-update-drawer-closed')
      }

      closeStatusDrawer(evt)
    }

    return (
      <BottomDrawer
        title="Update Status"
        className="StatusUpdateDrawer"
        onClose={onClose}
        isOpen={!!selectedStatus}
        fullscreen={selectedStatus && selectedStatus !== "true"}>
        <div className="StatusUpdateDrawer__subtitle">WHAT&apos;S THE STATUS?</div>
        <div className="StatusUpdateDrawer__status-buttons">
          {STATUS_BUTTONS.map(status => (
            <StatusButton
              key={status}
              previous={compareStatus(currentStatus, status) >= 0}
              checked={status === selectedStatus}
              onClick={() => onStatusClick(status)}>
              {labelFor(statusLabels, status)}
            </StatusButton>
          ))}
        </div>
        {selectedStatus === AGENT_STATUS_SPOKE && <StatusSpokeForm />}
        {selectedStatus === AGENT_STATUS_MET && <StatusMetForm />}
        {selectedStatus === AGENT_STATUS_OFFER && <StatusOfferForm/>}
        {selectedStatus === AGENT_STATUS_CONTRACT && <StatusContractForm/>}
        {selectedStatus === AGENT_STATUS_CLOSED && <StatusClosedForm/>}
      </BottomDrawer>
    )
  }
}

const selector = createStructuredSelector({
  is_lease: selectIsLease,
  currentStatus: selectAgentStatus,
})

const actions = {
  closeStatusDrawer,
  setSelectedStatus,
  showModal,
}

const withRedux = connect(selector, actions)

export const ReferralStatusUpdateDrawer = withRedux(withRouter(StatusUpdateDrawer))
